import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var alignProperties = {
  left: css(["margin-right:auto;"]),
  center: css(["margin-left:auto;margin-right:auto;"]),
  right: css(["margin-left:auto;"])
};

var getResponsiveProperties = function getResponsiveProperties(props) {
  var breakpoint = props.breakpoint,
      isFluid = props.isFluid;
  if (isFluid) return;

  if (breakpoint) {
    return css(["&{max-width:", "px;}"], theme("fannypack.layout." + breakpoint + "Breakpoint"));
  }

  return css(["@media (max-width:", "px){max-width:", "px;}@media (max-width:", "px){max-width:", "px;}@media (max-width:", "px){max-width:", "px;}"], function (props) {
    return theme('fannypack.layout.fullHDBreakpoint')(props) + 128;
  }, theme('fannypack.layout.widescreenBreakpoint'), function (props) {
    return theme('fannypack.layout.widescreenBreakpoint')(props) + 128;
  }, theme('fannypack.layout.desktopBreakpoint'), function (props) {
    return theme('fannypack.layout.desktopBreakpoint')(props) + 128;
  }, theme('fannypack.layout.tabletBreakpoint'));
};

var Container = styled(Box).withConfig({
  displayName: "styled__Container",
  componentId: "sc-144wh3b-0"
})(["width:100%;", ";", ";", ";", ";", ";", ";"], function (props) {
  return !props.isFluid && css(["max-width:", "px;"], theme('fannypack.layout.fullHDBreakpoint'));
}, function (props) {
  return props.isFluid && css(["padding-left:", ";padding-right:", ";"], theme('fannypack.Container.fluidMargin'), theme('fannypack.Container.fluidMargin'));
}, function (props) {
  return (props.isLayout || props.isFluid) && css(["@media (max-width:", "px){padding-left:", ";padding-right:", ";}"], theme('fannypack.layout.tabletBreakpoint'), theme('fannypack.Container.tabletMargin'), theme('fannypack.Container.tabletMargin'));
}, getResponsiveProperties, function (props) {
  return props.align && !props.isFluid ? alignProperties[props.align] : null;
}, theme('fannypack.Container.base'));
export default Container;
export { Container, alignProperties, getResponsiveProperties };